import Vue from 'vue';
import AdminAuthSignin from '@/views/Admin/Auth/AuthSignin';
import AdminDashboard from '@/views/Admin/Dashboard';
import AdminUncleAdd from '@/views/Admin/Uncle/UncleAdd';
import AdminUncleEdit from '@/views/Admin/Uncle/UncleEdit';
import AdminUncles from '@/views/Admin/Uncle/Uncles';
import AdminUserAdd from '@/views/Admin/User/UserAdd';
import AdminUserEdit from '@/views/Admin/User/UserEdit';
import AdminUsers from '@/views/Admin/User/Users';
import AuthSignin from '@/views/Auth/AuthSignin';
import AuthSignup from '@/views/Auth/AuthSignup';
import BroadcastCreate from '@/views/Broadcast/BroadcastCreate';
import BroadcastStatus from '@/views/Broadcast/BroadcastStatus';
import ExchangeStatus from '@/views/Exchange/ExchangeStatus';
import Index from '@/views/Dashboard';
import LogStatus from '@/views/Log/LogStatus';
import QuestionCreate from '@/views/Question/QuestionCreate';
import QuestionStatus from '@/views/Question/QuestionStatus';
import Router from 'vue-router';
import SaibApply from '@/views/Saib/SaibApply';
import SaibEdit from '@/views/Saib/SaibEdit';
import SaibSelector from '@/views/Saib/SaibSelector';
import SaibStatus from '@/views/Saib/SaibStatus';
import UncleSignin from '@/views/Uncle/Auth/AuthSignin';
import WholesaleStatus from '@/views/Wholesale/WholesaleStatus';
import UncleUnprocessed from '@/views/Uncle/Saib/Unprocessed';
import UnclePending from '@/views/Uncle/Saib/Pending';
import UnclePendingProperty from '@/views/Uncle/Saib/PendingProperty';
import AdminQuestion from '@/views/Admin/Question';
import UncleBroadcast from '@/views/Uncle/Broadcast';
import MasterSignin from '@/views/Master/Auth/AuthSignin';
import MasterUsersAdd from '@/views/Master/User/UserAdd';
import MasterUserEdit from '@/views/Master/User/UserEdit';
import WholesaleRequest from '@/views/Wholesale/Request';
import HistoryStatus from '@/views/History/HistoryStatus';
import ForgotPassword from '@/views/Auth/ForgotPassword';
import AdminForgotPassword from '@/views/Admin/Auth/ForgotPassword';
import UncleForgotPassword from '@/views/Uncle/Auth/ForgotPassword';
import UncleHistory from '@/views/Uncle/History';
import MasterUsers from '@/views/Master/User/Users';
import UncleTransform from '@/views/Uncle/Transform';
import MasterLocation from '@/views/Master/Location';
import AdminLocation from '@/views/Admin/Location';
import UncleSaibCompleted from '@/views/Uncle/Saib/Completed';
import UncleSaibCompletedProperty from '@/views/Uncle/Saib/CompletedProperty';
import UncleSaibLogs from '@/views/Uncle/Saib/Logs';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Index,
    },
    {
      path: '/signin',
      name: 'AuthSignin',
      component: AuthSignin,
    },
    {
      path: '/signup',
      name: 'AuthSignup',
      component: AuthSignup,
    },
    {
      path: '/saib',
      name: 'SaibStatus',
      component: SaibStatus,
    },
    {
      path: '/saib/selector',
      name: 'SaibSelector',
      component: SaibSelector,
    },
    {
      path: '/saib/apply',
      name: 'SaibApply',
      component: SaibApply,
    },
    {
      path: '/saib/edit',
      name: 'SaibEdit',
      component: SaibEdit,
    },
    {
      path: '/wholesale',
      name: 'WholesaleStatus',
      component: WholesaleStatus,
    },
    {
      path: '/broadcast/create',
      name: 'BroadcastCreate',
      component: BroadcastCreate,
    },
    {
      path: '/broadcast/:idx?',
      name: 'BroadcastStatus',
      component: BroadcastStatus,
    },
    {
      path: '/question/create',
      name: 'QuestionCreate',
      component: QuestionCreate,
    },
    {
      path: '/question/:idx?',
      name: 'QuestionStatus',
      component: QuestionStatus,
    },
    {
      path: '/exchange',
      name: 'ExchangeStatus',
      component: ExchangeStatus,
    },
    {
      path: '/logs',
      name: 'LogStatus',
      component: LogStatus,
    },
    {
      path: '/admin/signin',
      name: 'AdminAuthSignin',
      component: AdminAuthSignin,
    },
    {
      path: '/admin',
      name: 'AdminDashboard',
      component: AdminDashboard,
    },
    {
      path: '/admin/users',
      name: 'AdminUsers',
      component: AdminUsers,
    },
    {
      path: '/admin/users/add',
      name: 'AdminUsers',
      component: AdminUserAdd,
    },
    {
      path: '/admin/users/:idx',
      name: 'AdminUsers',
      component: AdminUserEdit,
    },
    {
      path: '/admin/uncles',
      name: 'AdminUncles',
      component: AdminUncles,
    },
    {
      path: '/admin/uncles/add',
      name: 'AdminUncles',
      component: AdminUncleAdd,
    },
    {
      path: '/admin/uncles/:idx',
      name: 'AdminUncles',
      component: AdminUncleEdit,
    },
    {
      path: '/admin/question',
      name: 'AdminQuestion',
      component: AdminQuestion,
    },
    {
      path: '/uncle/signin',
      name: 'UncleSignin',
      component: UncleSignin,
    },
    {
      path: '/uncle',
      name: 'UncleUnprocessed',
      component: UncleUnprocessed,
    },
    {
      path: '/uncle/pending',
      name: 'UnclePending',
      component: UnclePending,
    },
    {
      path: '/uncle/pending/:idx',
      name: 'UnclePending',
      component: UnclePendingProperty,
    },
    {
      path: '/uncle/broadcast',
      name: 'UncleBroadcast',
      component: UncleBroadcast,
    },
    {
      path: '/master',
      name: 'MasterUsers',
      component: MasterUsers,
    },
    {
      path: '/master/signin',
      name: 'MasterSignin',
      component: MasterSignin,
    },
    {
      path: '/master/users/add',
      name: 'MasterUsers',
      component: MasterUsersAdd,
    },
    {
      path: '/master/users/:idx',
      name: 'MasterUsers',
      component: MasterUserEdit,
    },
    {
      path: '/req/:idx',
      name: 'WholesaleRequest',
      component: WholesaleRequest,
    },
    {
      path: '/history',
      name: 'History',
      component: HistoryStatus,
    },
    {
      path: '/find',
      name: 'Find',
      component: ForgotPassword,
    },
    {
      path: '/find/:jwt',
      name: 'FindWithJWT',
      component: ForgotPassword,
    },
    {
      path: '/admin/find',
      name: 'AdminFind',
      component: AdminForgotPassword,
    },
    {
      path: '/admin/find/:jwt',
      name: 'AdminFindWithJWT',
      component: AdminForgotPassword,
    },
    {
      path: '/uncle/find',
      name: 'UncleFind',
      component: UncleForgotPassword,
    },
    {
      path: '/uncle/find/:jwt',
      name: 'UncleFindWithJWT',
      component: UncleForgotPassword,
    },
    {
      path: '/uncle/history',
      name: 'UncleHistory',
      component: UncleHistory,
    },
    {
      path: '/uncle/transform',
      name: 'UncleTransform',
      component: UncleTransform,
    },
    {
      path: '/master/location',
      name: 'MasterLocation',
      component: MasterLocation,
    },
    {
      path: '/admin/location',
      name: 'AdminLocation',
      component: AdminLocation,
    },
    {
      path: '/uncle/completed',
      name: 'UncleSaibCompleted',
      component: UncleSaibCompleted,
    },
    {
      path: '/uncle/completed/:idx',
      name: 'UncleSaibCompleted',
      component: UncleSaibCompletedProperty,
    },
    {
      path: '/uncle/logs',
      name: 'UncleSaibLogs',
      component: UncleSaibLogs,
    },
  ],
});

export default router;
